<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-05-22 15:56:37
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-22 11:32:14
-->
<!--
  分页封装
  props:
    pagination.sync
  event:
    on-change
  <Pagination :pagination.sync="pagination" @on-change="getListData"></Pagination>
-->
<template>
<div class="pagination-container">
  <pagination @size-change="handlePageSizeChange" @current-change="handlePageChange" :current-page="pagination.page" :page-sizes="[20, 50, 100, 200]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper">
  </pagination>
</div>
</template>

<script>
import {
  Pagination
} from 'zz-element-ui'
export default {
  name: 'ZPagination',
  components: {
    Pagination
  },
  props: {
    pagination: {
      type: Object,
      default: () => ({
        page: 1, // 页码
        limit: 20, // 每页大小
      })
    }
  },
  methods: {
    // 页码变化
    handlePageChange(page) {
      this.$emit('update:pagination', {
        ...this.pagination,
        page
      })
      // 页码发生变化
      this.$emit('on-change')
    },
    handlePageSizeChange(limit) {
      this.$emit('update:pagination', {
        ...this.pagination,
        page: 1, // 页码
        limit: limit, // 每页大小
      })
      this.$emit('on-change')
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  text-align: center;
  margin-top: 10px;
}
</style>
